<template>
  <div>

    <b-card class="mb-2">
      <b-row>
        <b-col cols="auto">
          <b-input-group>
            <b-form-select v-model="selectedYear" id="yearSelected" :options="yearOptions"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col>
          <b-button variant="outline-primary" size="sm" @click="listEnrollments()">
            <b-icon icon="check-circle"></b-icon> Actualizar Alumnos
          </b-button>
        </b-col>
        <b-col>
          <b-button variant="outline-primary" size="sm" @click="syncEnrollments()">
            <b-icon icon="check-circle"></b-icon> Sincronizar todos los Alumnos
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-row>
        <b-col>
          <b-table striped hover :busy="isBusy" :items="enrollments" :fields="enrollmentsFields">
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Cargando...</strong>
              </div>
            </template>
            <template #cell(display_name)="data">
              {{ data.item.display_name }}
            </template>
            <template #cell(x_class_id)="data">
              {{ data.item.x_class_id[1] }}
            </template>
            <template #cell(x_year_id)="data">
              {{ data.item.x_year_id[1] }}
            </template>
            <template #cell(x_year)="data">
              {{ data.item.x_year }}
            </template>
            <template #cell(actions)="data">
              <b-button @click="syncEnrollmentYear(data.item.id, data.item.x_class_id[0])">Sincronizar año</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { EnrollmentsService } from '@/services/enrollments.service'
export default {
  name: 'IndexPage',
  data () {
    return {
      name: 'asd',
      isBusy: true,
      selectedYear: null,
      enrollments: [],
      years: [],
      enrollmentsFields: [
        { key: 'display_name', label: 'Alumno/a' },
        { key: 'x_year_id', label: 'x Year ID' },
        { key: 'x_class_id', label: 'Clase' },
        { key: 'x_year', label: 'X YEAR' },
        { key: 'actions', label: 'Acciones' }
      ]
    }
  },
  async created () {
    this.years = this.$store.state.year.list
    this.year = this.$store.state.year.selected
    this.selectedYear = this.year.id
    await this.listEnrollments()
    this.isBusy = false
    // this.projectList = await ProjectsService.list()
  },
  computed: {
    yearOptions () {
      // console.log('loading years options...')
      const opts = []
      for (var i = 0; i < this.years.length; i++) {
        opts.push({ value: this.years[i].id, text: this.years[i].x_year })
      }
      return opts
    }
  },
  methods: {
    async syncEnrollments () {
      this.isBusy = true
      try {
        this.enrollments = await EnrollmentsService.syncYears(this.selectedYear)
        this.listEnrollments()
      } catch (error) {
        console.log(error)
      }
    },
    async listEnrollments () {
      // console.log(this.selectedYear)
      this.enrollments = await EnrollmentsService.list({}, ['x_year_id', '=', this.selectedYear])
      this.isBusy = false
    },
    async syncEnrollmentYear (enrollmentId, classId) {
      // console.log('sincronizar año de cursada de ', enrollmentId, classId)
      try {
        await EnrollmentsService.syncEnrollmentYear(enrollmentId, classId)
        this.listEnrollments()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
